import { useState, useEffect, useContext } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ConfigContext } from "../../../Context/ConfigContext";
import { useTranslation } from 'react-i18next';
import { OverlayLoader, Spinner } from "../../../Components/Shimmers";
import CartItem from "../CartItem";
import { CartsContext } from "../../../Context/CartsContext";

import Swal from "sweetalert2"
import { axiosGet, axiosPost } from "../../../Apis/axiosMethods";

function BasketConfirm() {

    const {
        lang,
        paymentMethod,
        setIsCartUpdate,
        business_type,
        removePaymentMethod,
        currency,
    } = useContext(ConfigContext);

    const { cartItems, cartLoading, cartData } = useContext(CartsContext);

    const [min_purchase_amount, setMinPurchasePrice] = useState(false)

    const business_id = localStorage.getItem("business_id");
    const order_type = [250801, 250807, 250808, 250809, 250811, 250812, 250814, 250817, 250824, 250835, 250875, 250982, 250983, 250984, 251169, 251188, 251276].includes(Number(business_id)) ? 1 : 0;

    const location = useLocation();
    const pathname = location.pathname;

    const { t } = useTranslation();
    const [customersAddresses, setCustomersAddresses] = useState([]);
    const [placeOrderLoading, setPlaceOrderLoading] = useState(false);

    const [specialInstruction, setSpecialInstruction] = useState('');
    const [ref_clint, setRefClient] = useState('');

    const [userInfo, setUserInfo] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        if (!paymentMethod) {
            window.location = '/basket/payment';
        }
    }, [])

    useEffect(() => {
        GetAddresses();
        GetUserInfo();
        GetBusinessInfo();
    }, []);


    const GetUserInfo = async () => {
        try {
            const business_user_id = localStorage.getItem("business_user_id");

            const response = await axiosGet(`/Users/GetUserInfo?business_user_id=${business_user_id}`,);

            const data = response.data;

            if (data.success) {
                setUserInfo(data.data[0]);
            } else {
                console.log("Error While Fetching User Info", data.message);
            }
        } catch (error) {
            console.log("Oops Something Went Wrong", error);
        }
    };

    const GetBusinessInfo = async () => {
        try {
            const business_id = localStorage.getItem("business_id");

            const response = await axiosGet(`/Users/GetBusinessInfo?business_id=${business_id}`,);

            const data = response.data;

            if (data.success) {
                setMinPurchasePrice(data?.data[0]?.country_min_purchase);
            } else {
                console.log("Error While Fetching User Info", data.message);
            }
        } catch (error) {
            console.log("Oops Something Went Wrong", error);
        }
    };

    const GetAddresses = async () => {
        try {
            const business_id = localStorage.getItem("business_id");

            const response = await axiosGet(`/Users/GetAddresses?business_id=${business_id}`,);

            const data = response.data;

            if (data.success) {
                if (data.data.length > 0) {
                    const defaultAddress = data.data.find(address => address.default_address === '1');

                    if (defaultAddress) {
                    } else {
                        window.location = '/basket/address'
                    }
                } else {
                    window.location = '/basket/address'
                }

            } else {
                window.location = '/basket/address'
            }
        } catch (error) {
            window.location = '/basket/address'
        }
    };

    const handlePlaceOrder = async () => {
        if (placeOrderLoading) {
            return false;
        }

        const requestData = {
            lang: lang,
            business_id: Number(localStorage.getItem('business_id')),
            business_order_address_id: selectedAddress ? selectedAddress.business_address_id : 0,
            special_instruction: specialInstruction,
            currency: currency,
            business_order_payment_method: paymentMethod,
            coupon: localStorage.getItem("coupon"),
            total_saving: cartData?.total_saving,
            business_type,
            order_type,
            business_order_ref_client: ref_clint
        };

        try {
            setPlaceOrderLoading(true);

            const response = await axiosPost(`/Orders/PlaceOrder`, requestData);

            const data = response.data;

            if (data.success === false) {
                setPlaceOrderLoading(false);
            }

            if (data.success) {
                setIsCartUpdate(prev => !prev)
                localStorage.removeItem("coupon");
                removePaymentMethod()
                if (paymentMethod.toLowerCase() === 'tabby') {
                    var tabby_redirect = data.tabbpy_response.response.configuration.available_products.installments[0].web_url;

                    if (data.tabbpy_response.success) {
                        window.location = tabby_redirect;
                    }
                } else if (paymentMethod.toLowerCase() === 'cod' || paymentMethod.toLowerCase() === 'bank' || paymentMethod.toLowerCase() === 'credit') {
                    navigate(`/OrderInformation/${data.secret_order_id}`, { replace: true });
                } else {
                    window.history.replaceState(null, '', '/');
                    window.location.href = `https://b2bpay.ghayar.com/pay?order_id=${data?.secret_order_id}&origin=business&order_uid=${data?.secret_order_id}`;
                }
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Order Failed",
                    text: data.message || "Something went wrong while placing your order.",
                    confirmButtonText: "OK",
                });
            }
        } catch (error) {
            console.error("Error placing order:", error);
        } finally {
            setPlaceOrderLoading(false);
        }
    };

    const dir = localStorage.getItem('dir');
    const [selectedAddress, setSelectedAddress] = useState([]);

    useEffect(() => {
        getCustomerAddresses();
    }, []);

    const getCustomerAddresses = async () => {
        try {
            const business_id = localStorage.getItem("business_id");

            const response = await axiosGet(`/Users/GetAddresses?business_id=${business_id}`);

            const data = response.data;

            if (data.success) {
                console.log("data.data", data.data)
                setCustomersAddresses(data.data);

                setSelectedAddress(data.data.find((item) => item.default_address === "1"));
            } else {
                navigate('/basket/address')
            }

        } catch (error) {
            console.log("Oops Something Went Wrong", error);
        }
    };

    const hasOutOfStock = cartItems?.some((item) => item?.part_available === false);

    const cartDisplayAmount = Number(
        cartData?.sub_total_display
            ?.replace(/[^\d.-]/g, "")
    ) || 0;

    const isBelowMinimumPurchase = min_purchase_amount > 0 && cartDisplayAmount < min_purchase_amount;

    return (
        <>
            {
                cartLoading ?
                    <div style={{ height: "70vh" }}>
                        <OverlayLoader />
                    </div>
                    :
                    <main className="main" style={{ textAlign: dir === 'rtl' ? 'right' : '' }} dir={dir}>
                        <ToastContainer position="bottom-center" autoClose={1000} theme="dark" hideProgressBar />
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-8 mt-2">
                                    <div style={{ display: localStorage.getItem('business_id') === '' ? 'none' : '' }}>
                                        <p><h2 className="step-title" style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}>{t('shipping_address')}</h2></p>
                                        <div className="cart-summary p-2" style={{ borderRadius: "2%" }}>
                                            {customersAddresses.length > 0 ? (
                                                <div className="container">

                                                    <div className="row">
                                                        <div className="col-md-6 mt-2" style={{ textAlign: dir === 'rtl' ? 'right' : 'left', paddingRight: dir === 'rtl' ? '50px' : '' }}>
                                                            <span className="product-description__item-title ml-4" style={{ fontSize: '16px' }}>{t("billing_address_and_delivery_address")}</span>
                                                            {selectedAddress && <div className="ml-4" key={selectedAddress.address_id} style={{ lineHeight: "30px" }} >
                                                                <div className="h5 mb-0"> {selectedAddress.business_address_title}  </div>
                                                                <div className="mt-0">
                                                                    {selectedAddress.business_full_address} <br />
                                                                    {selectedAddress.business_city}, {selectedAddress.state}<br />
                                                                    {selectedAddress.pincode}, {selectedAddress.country}
                                                                </div>
                                                                {selectedAddress.mobile_number_2 && selectedAddress.mobile_number_2 > 0 ?
                                                                    <div>
                                                                        <p> {selectedAddress.mobile_number_2}{" "}
                                                                            {/* <span className="text-primary"> {"Verify now"} </span>  */}
                                                                        </p>
                                                                    </div> : <></>}
                                                                <span onClick={() => window.location = `/basket/address?backUrl=${window.location.href}`} className="text-primary link-blue"> {t('change')} </span>

                                                            </div>}
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="card-body" style={{ minHeight: 'unset', textAlign: dir === 'rtl' ? 'right' : 'left' }}>
                                                                <span className="product-description__item-title ml-4" style={{ fontSize: '16px', textAlign: 'left' }}>{t("payment_method")}</span>
                                                                {
                                                                    paymentMethod === 'online' && <div className="col-lg-12" style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}>
                                                                        <span className="ml-2" style={{ fontSize: '13px', fontWeight: 500 }}>{t('online_payments_recommended')}</span>
                                                                        <div className="col-lg-12">
                                                                            <img src="/assets/images/payment/visa.svg" alt="Visa" className="payment-icon" style={{ width: '40px', display: 'inline-block', marginLeft: '-5px' }} />
                                                                            <img src="/assets/images/payment/mc.svg" alt="Mastercard" className="payment-icon" style={{ width: '40px', display: 'inline-block' }} />
                                                                            <img src="/assets/images/payment/ae.svg" alt="American Express" className="payment-icon" style={{ width: '40px', display: 'inline-block' }} />
                                                                        </div>

                                                                    </div>

                                                                }

                                                                {
                                                                    paymentMethod === 'bank' && <div className="col-lg-12" style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}>
                                                                        <span className="ml-2" style={{ fontSize: '13px', fontWeight: 500 }}>{t('bank_transfer')}</span>
                                                                        <div className="col-lg-12"  >
                                                                            <img src="/assets/images/payment/bank_transfer.svg" alt="Bank Transfer" className="payment-icon" style={{ width: '60px', display: 'inline-block', marginLeft: '-5px' }} />

                                                                        </div>

                                                                    </div>

                                                                }

                                                                {
                                                                    paymentMethod === 'cod' && <div className="col-lg-12" style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}>
                                                                        <span className="ml-2" style={{ fontSize: '13px', fontWeight: 500 }}>{t('cash_on_delivery')}</span>
                                                                        <div className="col-lg-12">
                                                                            <img src="/assets/images/payment/cod.svg" alt="Bank Transfer" className="payment-icon" style={{ width: '60px', marginTop: '-10px', display: 'inline-block', marginLeft: '-5px' }} />

                                                                        </div>

                                                                    </div>

                                                                }

                                                                {
                                                                    paymentMethod === 'credit' && <div className="col-lg-12" style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}>
                                                                        <span className="ml-2" style={{ fontSize: '13px', fontWeight: 500 }}>Credit Balance</span>
                                                                        <div className="col-lg-12">
                                                                            <img src="/assets/images/credit.png" alt="Bank Transfer" className="payment-icon" style={{ width: '30px', display: 'inline-block', marginLeft: '-5px' }} />

                                                                        </div>

                                                                    </div>

                                                                }

                                                                <div className="col-lg-12 ml-3 mt-1" style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}>
                                                                    <span onClick={() => window.location = `/basket/payment`} className="text-primary link-blue" style={{ marginLeft: '-5px' }}> {t('change')} </span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>
                                            ) : (
                                                <div className="d-flex justify-content-center" style={{ height: '100px', padding: '40px' }}>
                                                    <span onClick={() => window.location = `/basket/address?backUrl=${window.location.href}`} className="text-primary" style={{ cursor: 'pointer' }}> {t('add_new_address')} </span>


                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {cartLoading ?
                                        <center>
                                            <Spinner />
                                        </center>
                                        :
                                        cartItems ? (
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="cart-table-container">
                                                        {cartItems?.map((item, index) => (
                                                            <CartItem key={item.item_id} item={item} index={index} pathname={pathname} />
                                                        ))}
                                                    </div>
                                                </div>


                                            </div>
                                        ) : (
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="cart-table-container cart-summary">
                                                        <div className="d-flex justify-content-center">
                                                            <h5>{t("your_cart_is_empty")}</h5>
                                                        </div>
                                                        <div className="checkout-methods d-flex justify-content-center">
                                                            <NavLink to="/" className="btn btn-dark btn-lg px-5">
                                                                {t("shop_now")}
                                                                <i className="fa fa-arrow-right" />
                                                            </NavLink>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                </div>
                                <div className="col-lg-4 mt-2">
                                    <p><h2 className="step-title" dir={dir} style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}>{t('order_summary')}</h2></p>
                                    <div className="cart-summary p-3 mb-1" style={{ borderRadius: "3%", textAlign: dir === 'rtl' ? 'right' : 'left', direction: dir }} >
                                        <h5 style={{ lineHeight: "1.5 rem", marginBottom: "0px", marginLeft: "10px", }} > {t("order_details")} </h5>
                                        <table className="table table-totals mb-0">
                                            {cartItems &&
                                                cartItems?.map((item, index) => (
                                                    <tr key={item.item_id}>
                                                        <td className="custom-light">
                                                            {index + 1}. {item.item_title} x {item.item_qty}
                                                        </td>
                                                        <td className="float-right">
                                                            {item.total_display_price}
                                                        </td>
                                                    </tr>
                                                ))}
                                        </table>
                                        {cartItems && (
                                            <>
                                                <table className="table table-totals mb-0">
                                                    <tbody>
                                                        <tr style={{ border: "none", marginBottom: "0px" }}>
                                                            <td style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}>
                                                                {Number(cartData?.total_saving) > 0 ? "Sub Total" : "Taxable Amount"}
                                                            </td>
                                                            <td
                                                                style={{ textAlign: dir !== 'rtl' ? 'right' : 'left' }}
                                                                className="custom-dark"
                                                            >
                                                                <span>{cartData?.sub_total_display}</span>
                                                            </td>
                                                        </tr>

                                                        {
                                                            cartData?.free_shipping ?
                                                                <tr style={{ border: "none", marginBottom: "0px" }}>
                                                                    <td style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}>
                                                                        {t("shipping")}
                                                                    </td>
                                                                    <td style={{ textAlign: dir !== 'rtl' ? 'right' : 'left' }}>
                                                                        <div
                                                                            className="alert-success"
                                                                            style={{
                                                                                padding: '5px',
                                                                                width: '100%',
                                                                                textAlign: 'center',
                                                                                border: '2px dotted'
                                                                            }}
                                                                        >
                                                                            {t('free_shipping_all_over_nation')}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                :
                                                                Number(cartData?.shipping_cost) > 0 &&
                                                                <tr style={{ border: "none", marginBottom: "0px" }}>
                                                                    <td style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}>
                                                                        {t("shipping")}
                                                                    </td>
                                                                    <td style={{ textAlign: dir !== 'rtl' ? 'right' : 'left' }}>
                                                                        <span>{cartData?.display_shipping_cost}</span>
                                                                    </td>
                                                                </tr>
                                                        }

                                                        {paymentMethod === 'cod' && cartData?.cod_applicable &&
                                                            <tr style={{ border: "none", marginBottom: "0px" }}>
                                                                <td style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}>
                                                                    {t("cod")}
                                                                </td>
                                                                <td style={{ textAlign: dir !== 'rtl' ? 'right' : 'left' }}>
                                                                    <span>
                                                                        {cartData?.cod_charges > 0
                                                                            ? cartData?.display_cod_charges
                                                                            : (
                                                                                <div
                                                                                    className="alert-success"
                                                                                    style={{
                                                                                        padding: '5px',
                                                                                        width: '100%',
                                                                                        textAlign: 'center',
                                                                                        border: '2px dotted'
                                                                                    }}
                                                                                >
                                                                                    {t('cash_on_delivery_free')}
                                                                                </div>
                                                                            )}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        }

                                                        {localStorage.getItem("coupon") &&
                                                            Number(cartData?.total_saving) > 0 && (
                                                                <>
                                                                    <tr style={{ border: "none", marginBottom: "0px" }}>
                                                                        <td>
                                                                            {t('total_saving')}
                                                                            <span
                                                                                className="text-success alert-success"
                                                                                style={{
                                                                                    padding: "1px 5px",
                                                                                    border: "1px dashed",
                                                                                    marginLeft: "5px"
                                                                                }}
                                                                            >
                                                                                {localStorage.getItem("coupon")}
                                                                            </span>
                                                                        </td>
                                                                        <td className="custom-dark">
                                                                            <span className="text-success">
                                                                                - {cartData?.total_saving_display}
                                                                            </span>
                                                                        </td>
                                                                    </tr>

                                                                    <tr style={{ border: "none", marginBottom: "0px" }}>
                                                                        {/* <td>{t("Net Amount")}</td> */}
                                                                        <td>{t("Taxable Amount")}</td>
                                                                        <td className="custom-dark">
                                                                            <span>{cartData?.net_amount_display}</span>
                                                                        </td>
                                                                    </tr>
                                                                </>
                                                            )}

                                                        {Number(cartData?.vat_amount) > 0 && (
                                                            <tr style={{ border: "none", marginBottom: "0px" }}>
                                                                <td>
                                                                    {t("VAT")} ({cartData?.vat_percent}%)
                                                                </td>
                                                                <td className="custom-dark">
                                                                    <span>{cartData?.vat_amount_display}</span>
                                                                </td>
                                                            </tr>
                                                        )}

                                                    </tbody>

                                                    <tfoot>
                                                        <tr>
                                                            <td>{t("grand_total")}</td>
                                                            <td className="custom-dark">
                                                                <span>{cartData?.grand_total_display}</span>
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </table>

                                            </>
                                        )}
                                    </div>
                                    <div className="checkout-methods">
                                        {
                                            currency.toLowerCase() !== "usd" &&
                                            <div className="alert alert-success">
                                                <lord-icon
                                                    src="https://cdn.lordicon.com/nkmsrxys.json"
                                                    trigger="loop"
                                                    style={{ width: '60px', height: '60px' }}
                                                ></lord-icon>

                                                You will get
                                                <span className="ml-2 mr-2">
                                                    <b>{cartData?.points ?? 0} rewards points</b>
                                                </span>
                                                on this order
                                            </div>
                                        }

                                        {
                                            localStorage.getItem('business_id') === '' ?
                                                <span className="alert alert-danger">Please login or create account before place order</span>
                                                : <div></div>
                                        }

                                        <div className="d-flex justify-content-center mb-2">
                                            <table style={{ width: '100%', textAlign: 'left' }}>
                                                <tr>
                                                    <td>
                                                        <label
                                                            style={{ width: '100%' }}
                                                        >
                                                            Ref Client
                                                        </label>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        <textarea
                                                            value={ref_clint}
                                                            onChange={(e) => setRefClient(e.target.value)}
                                                            placeholder="Enter reference client name or details (e.g. company name, contact person, etc.)"
                                                            className="form-control"
                                                            rows="3"
                                                            style={{ width: '100%' }}
                                                        >
                                                        </textarea>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        <label
                                                            style={{ width: '100%' }}
                                                        >
                                                            Any Special Instruction <small>(optional)</small>
                                                        </label>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        <textarea
                                                            value={specialInstruction}
                                                            onChange={(e) => setSpecialInstruction(e.target.value)}
                                                            placeholder="Please write here if you have any special instructions..."
                                                            className="form-control"
                                                            rows="3"
                                                            style={{ width: '100%' }}
                                                        >
                                                        </textarea>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                        {
                                            hasOutOfStock ? (

                                                <div
                                                    className="alert alert-danger text-center mt-2"
                                                    style={{
                                                        fontSize: "14px",
                                                        fontWeight: "600"
                                                    }}
                                                >
                                                    Please remove out of stock items to continue checkout.
                                                </div>
                                            ) : currency.toLowerCase() === "usd" && isBelowMinimumPurchase ?
                                                <div
                                                    className="alert alert-warning text-center mt-2"
                                                    style={{
                                                        fontSize: "14px",
                                                        fontWeight: "600",
                                                    }}
                                                >
                                                    Minimum purchase amount is {min_purchase_amount}
                                                    Please add more items to continue.
                                                </div>
                                                : paymentMethod && userInfo && userInfo.purchaser === 1 && cartItems?.length > 0 &&
                                                <button
                                                    type="button"
                                                    style={{ borderRadius: "3%" }}
                                                    className={placeOrderLoading === true ? "btn btn-block btn-default" : "btn btn-block btn-primary"}
                                                    onClick={handlePlaceOrder}
                                                    disabled={placeOrderLoading}
                                                >
                                                    {placeOrderLoading === true ? "Please wait..." : t("place_order")}

                                                </button>
                                        }

                                    </div>
                                    <div className="text-dark" dir={dir} style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}>
                                        <div className="mt-2">
                                            {(" ")}<i className="fas fa-solid fa-lock mr-1"></i>{(" ")}
                                            <strong className="" style={{ color: 'grey' }}>{t("security_and_privacy")}</strong>
                                        </div>
                                        <div className="mt-1">
                                            {t("checkout_safe")}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mb-6" />
                    </main >
            }
        </>
    );
}

export default BasketConfirm;
